module.exports = __webpack_public_path__ + "static/img/40-2.d0a9fdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/40-2.jpg
// module id = a6LY
// module chunks = 0